// extracted by mini-css-extract-plugin
module.exports = {"menuRow":"styles__menuRow___3xUVb","menuRowIcon":"styles__menuRowIcon___19yK3","menuSeparator":"styles__menuSeparator___2d-Yv styles__menuRow___3xUVb"};